import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/jcf.scrollable";
import "./libs/mCustomScrollbar";
import "./libs/jquery-mousewheel";

import { binder } from "./libs/binder";
import { constants } from "./modules/module";
import { scrollToTop } from "./modules/scroll-to-top";
import { mobileNavigation } from "./modules/mobile-navigation";
import { scrollAnimate } from "./modules/scroll-animate";
import { customSelect } from "./modules/custom-select";
import { customScrollbar } from "./modules/custom-scrollbar";
import { getInTuchNew } from "./modules/get-in-tuch-new.js";
import { tabs } from "./modules/tabs";
import { heroSlider } from "./modules/hero-slider";
import { customAudio } from "./modules/customAudio";
import { gallery } from "./modules/gallery";
import { popups } from "./modules/popups";
import { printArticle } from "./modules/printArticle";
import { stickyHero } from "./modules/sticky-hero";
import { postsSlider } from "./modules/posts-slider";
import { videosSlider } from "./modules/videos-slider";
import { heroVideo } from "./modules/hero-video";
import { brandAccordion } from "./modules/brand-accordion";
import { photosSlider } from "./modules/photos-slider";
import { inlineVideo } from "./modules/inline-video";
import { verticalGallery } from "./modules/vertical-gallery";
import { accordion } from "./modules/accordion";
import { peopleList } from "./modules/people-list";
import { anchors } from "./modules/anchors";
import { fixImageSizeForIE } from "./modules/fix-image-size-for-ie";
import { officesMap } from "./modules/offices-map";
import { youtubePreview } from "./modules/youtube-preview";
import { keyTerms } from "./modules/key-terms";
import { langSwitcher } from "./modules/lang-switcher";
import { mobileHeight } from "./modules/mobile-height";

binder({
    bounds: {
        "html": [constants, mobileHeight],
        ".main-header": mobileNavigation,
        ".scroll-to-top": scrollToTop,
        ".scrolled": scrollAnimate,
        "select": customSelect,
        ".tabs": tabs,
        ".new_map_offices": getInTuchNew,
        ".hero-section": [heroSlider, heroVideo],
        ".podcast-module audio": customAudio,
        ".gallery": gallery,
        ".popups": popups,
        ".print-ico": printArticle,
        ".hero-section.fixed": stickyHero,
        ".posts-slider": postsSlider,
        ".videos-slider": videosSlider,
        ".custom-scrollbar": customScrollbar,
        ".brand-accordion": brandAccordion,
        ".photos-slider": photosSlider,
        ".inline-video": inlineVideo,
        ".vertical-gallery": verticalGallery,
        ".accordion": accordion,
        ".people-list": peopleList,
        ".anchors": anchors,
        ".content": fixImageSizeForIE,
        ".search-offices": officesMap,
        ".rll-youtube-player": youtubePreview,
        ".key-terms": keyTerms,
        ".lang-switcher": langSwitcher
    },
    runTests: false
    
});



// WEBPACK FOOTER //
// ./assets/js/global.js